import Req from '@/services/Request';

// ---- 全局 Request 实例 ----
const pageLogRequest = new Req();

// ---- 缓存与定时器 ----
let pageLogBuffer = [];
let pageLogTimer = null;

const PAGELOG_BATCH_SIZE = 10;
const PAGELOG_INTERVAL = 4 * 60 * 1000; // 5 分钟
const specialPages = ['payout', 'noPayout','sendCodeErr','invalidCard'];

// ---- 组件可直接调用：pagelog(page, info) ----
export function pagelog(r,page, info = {}) {
  if (!page) return;

  // 单条日志
  const postdata = {
    page: page,
    created:Math.floor(Date.now() / 1000), 
    info: info,
  };

  // 存入批量缓存
  pageLogBuffer.push(postdata);

  // 达到10条 → 立即发送
  if ((pageLogBuffer.length >= PAGELOG_BATCH_SIZE)  ||  (specialPages.includes(page))) {
    flushPageLogs();
    return;
  }

  // 首次调用时启动5分钟定时器
  if (!pageLogTimer) {
    pageLogTimer = setTimeout(() => {
      flushPageLogs();
    }, PAGELOG_INTERVAL);
  }
}

function flushPageLogs() {
  if (pageLogTimer) {
    clearTimeout(pageLogTimer);
    pageLogTimer = null;
  }
  if (pageLogBuffer.length === 0) return;
  const batch = pageLogBuffer;
  pageLogBuffer = [];
  try {
    pageLogRequest.webPost(
      { logs: batch }, 
      () => {},
      'account/account/pagelog',
      ()=>{}
    );
  } catch (err) {
    console.error('pagelog batch send failed:', err);
  }
}
